const MODULE_NAME = 'DiagramModule';

export const GET_CURRENT_CELL_INDEX = `${MODULE_NAME}/GET_CURRENT_CELL_INDEX`;
export const GET_KEYPAD_NEXT_BUTTON_TABLE_BUBBLE = `${MODULE_NAME}/GET_KEYPAD_NEXT_BUTTON_TABLE_BUBBLE`;
export const GET_CURRENT_MEASURMENT_TABLE_CELL = `${MODULE_NAME}/GET_CURRENT_MEASURMENT_TABLE_CELL`;
export const GET_CURRENT_DISPLAY_UNIT = `${MODULE_NAME}/GET_CURRENT_DISPLAY_UNIT`;
